import {Theme} from '@material-ui/core'
import {CSSProperties} from '@material-ui/core/styles/withStyles'

export const styles = (theme: Theme): Record<string, CSSProperties> => ({
  root: {
    flexGrow: 1,
  },
  blueAvatar: {
    margin: 10,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.lightblue.color,
    [theme.breakpoints.down('xs')]: {
      margin: '0 10px 0 0',
      height: 35,
      width: 35,
      lineHeight: 37,
    },
  },
  notValid: {
    color: theme.palette.error.main,
    fontSize: 12,
    fontWeight: 400,
  },
  valid: {
    color: theme.palette.green.color,
    fontSize: 14,
    fontWeight: 400,
  },
  underReview: {
    color: theme.palette.yellow.color,
    fontSize: 14,
    fontWeight: 400,
  },
  pending: {
    color: theme.palette.yellow.color,
    fontSize: 14,
    fontWeight: 400,
  },
  approved: {
    color: theme.palette.green.color,
    fontSize: 14,
    fontWeight: 400,
  },
  rejected: {
    color: theme.palette.error.main,
    fontSize: 14,
    fontWeight: 400,
  },
  statusIcon: {
    verticalAlign: 'middle',
    fontSize: 14,
    marginRight: 8,
  },
  doneIcon: {
    color: theme.palette.green.color,
  },
  removeIcon: {
    color: theme.palette.error.main,
  },
  subtitle: {
    color: theme.palette.grey.color,
    fontWeight: 300,
  },
  toolTip: {
    color: theme.palette.secondary.light,
    fontSize: 14,
    fontWeight: 300,
    padding: 3,
  },
  tool: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: 0,
      top: -15,
    },
  },
  toolOuter: {
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
    },
  },
  disabledCard: {
    '&:hover': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
})
